import dashboard from '../views/dashboard';

export default [
  {
    path: '/dashboard',
    key: 'dashboard',
    component: dashboard
  }
];
